import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SystemService } from '../../services/system.service';

@Injectable({
	providedIn: 'root',
})
export class EmailIntakeService {
	constructor(private http: HttpClient, private systemService: SystemService) {}

	private base(): string {
		return this.systemService.apiUrl('orders/emailintake');
	}

	getSchema(): Observable<any> {
		return this.http.get(this.base() + '/get_schema');
	}

	list(kind: string, state: string): Observable<any> {
		let params = new HttpParams();
		if (kind) {
			params = params.set('kind', kind);
		}
		if (state) {
			params = params.set('state', state);
		}
		return this.http.get(this.base() + '/list', { params });
	}

	get(id: number): Observable<any> {
		return this.http.post(this.base() + '/get', { id }, this.systemService.httpOptions);
	}

	triggerPoll(): Observable<any> {
		return this.http.post(this.base() + '/trigger_poll', {}, this.systemService.httpOptions);
	}

	listAudit(id: number): Observable<any> {
		return this.http.get(this.base() + '/list_audit', { params: new HttpParams().set('id', String(id)) });
	}

	reclassify(id: number, intakeKind: string): Observable<any> {
		return this.http.post(this.base() + '/reclassify', { id, intake_kind: intakeKind }, this.systemService.httpOptions);
	}

	reextract(id: number): Observable<any> {
		return this.http.post(this.base() + '/reextract', { id }, this.systemService.httpOptions);
	}

	reject(id: number): Observable<any> {
		return this.http.post(this.base() + '/reject', { id }, this.systemService.httpOptions);
	}

	previewPost(id: number, postPayload: any): Observable<any> {
		return this.http.post(this.base() + '/preview_post', { id, post_payload: postPayload }, this.systemService.httpOptions);
	}

	commitPost(id: number, postPayload: any, confirmToken: string): Observable<any> {
		return this.http.post(
			this.base() + '/commit_post',
			{ id, post_payload: postPayload, confirm_token: confirmToken },
			this.systemService.httpOptions,
		);
	}

	downloadAttachment(id: number, name: string): Observable<any> {
		return this.http.post(this.base() + '/download_attachment', { id, name }, this.systemService.httpOptions);
	}

	testConnection(): Observable<any> {
		return this.http.post(this.base() + '/test_connection', {}, this.systemService.httpOptions);
	}

	aiStatus(): Observable<any> {
		return this.http.get(this.base() + '/ai_status');
	}
}
